export default "__VITE_ASSET__BLTuq4OY__"